import { Injectable } from '@angular/core';
import { BaseSelectionService } from './base-selection';
import { PendingSalesOrder } from './pending-order-service';

@Injectable({ providedIn: 'root' })
export class PendingOrderSelectionService extends BaseSelectionService<PendingSalesOrder> {
}
